import { Tag } from 'tuui';
import { FormattedMessage } from 'modules/taboola-common-frontend-modules/i18n';
import styles from './recommendedTag.module.scss';

export const RecommendedTag = () => {
    return (
        <div className={styles['recommended-tag']}>
            <Tag variant={Tag.variant.outlined} size={Tag.size.sm}>
                <FormattedMessage id="onboarding.journey.recommended" defaultMessage="Recommended" />
            </Tag>
        </div>
    );
};
